module.exports = __webpack_public_path__ + "img/tm.6035fa1c.png";